var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 794,
    height: 1117,
    viewBox: "0 0 794 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.092 1062.12C575.863 1062.12 641.53 876.972 641.53 719.78C641.53 562.589 575.863 377.442 389.092 377.442C202.321 377.442 136.655 562.589 136.655 719.78C136.655 876.972 202.321 1062.12 389.092 1062.12ZM0 -81.8839C0 -132.545 29.4098 -164 76.1026 -164C122.795 -164 152.164 -132.545 152.164 -81.8839V370.484H155.629C195.433 312.866 280.156 244.706 401.219 244.706C650.192 244.706 793.735 473.515 793.735 719.78C793.735 966.046 650.192 1194.85 401.219 1194.85C280.156 1194.85 198.857 1151.19 155.629 1067.37H152.164V1112.78C152.164 1163.4 122.795 1194.85 76.1026 1194.85C29.4098 1194.85 0 1163.4 0 1112.78V-81.8839Z",
    fill: "#080712",
    fillOpacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseB);
export default __webpack_public_path__ + "static/media/briefcase-b.c438d3e650dfd525f0b0e096296a0301.svg";
export { ForwardRef as ReactComponent };